import { Button, Group, Modal, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { TAnswer, TQuiz } from "../../types/Aula";
import { useState } from "react";


export const ConfirmModal = ({
    confirmModalOpen,
    setConfirmModalOpen,
    submitValues,
    handleSubmit,
    quiz,
}: {
    confirmModalOpen: boolean;
    setConfirmModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    submitValues: TAnswer[] | Record<string, string>
    handleSubmit: () => Promise<void> | void;
    quiz: TQuiz | null;
}) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await handleSubmit();
            setConfirmModalOpen(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            opened={confirmModalOpen}
            onClose={() => {}}
            title={t("quiz.areYouSure")}
            centered
            withCloseButton={false}
        >
            {(quiz?.category === "quiz" && submitValues.length !== quiz?.questions.length) && (
                <Text c="red" size="sm">{t("quiz.incompleteQuiz")}</Text>
            )}
            <Group p="right" mt="md">
                <Button variant="outline" onClick={() => setConfirmModalOpen(false)} loading={loading}>
                    {t("actions.cancel")}
                </Button>
                <Button onClick={handleConfirm} loading={loading}>
                    {t("actions.submit")}
                </Button>
            </Group>
        </Modal>
    );
}